/**
 * Hero scène suit la variante choisie (custom.hero_variante, sinon featured
 * paysage ≥ 1600 px). Table JSON rendue par sections/moojo-origin.liquid.
 */
(function () {
  function bindMap(mapEl) {
    const match = /^moojo-hero-variant-map-(.+)$/.exec(mapEl.id || '');
    if (!match) return;
    const sectionId = match[1];
    const img = document.getElementById('moojo-origin-hero-' + sectionId);
    if (!img) return;

    let table;
    try {
      table = JSON.parse(mapEl.textContent);
    } catch (_) {
      return;
    }
    if (!table || !table.default) return;

    const formId = table.meta && table.meta.formId;
    const form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    const apply = (variantId) => {
      const key = variantId != null ? String(variantId) : '';
      const entry = (key && table[key]) || table.default;
      if (!entry || !entry.src) return;
      img.src = entry.src;
      if (entry.srcset) {
        img.srcset = entry.srcset;
      } else {
        img.removeAttribute('srcset');
      }
      if (entry.alt != null) img.alt = entry.alt;
    };

    form.addEventListener('variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      apply(variant && variant.id);
    });
  }

  const run = () => {
    document.querySelectorAll('script[type="application/json"][id^="moojo-hero-variant-map-"]').forEach(bindMap);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
